export const legalInitialState = {
  legalPerson: '',
  termsAndConditions: false,
  rfc: '',
  firstName: '',
  lastName: '',
  businessName: ''
}
